export default class TokensModel {
    constructor(tokenType, accessToken, refreshToken) {
        this.tokenType = tokenType;
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }

    toString() {
        return JSON.stringify(this);
    }

    static fromString(str) {
        const { tokenType, accessToken, refreshToken } = JSON.parse(str);

        return new TokensModel(tokenType, accessToken, refreshToken);
    }
}